import React, { useState } from "react";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
// import { readAndCompressImage } from "browser-image-resizer";

import {
  Timestamp,
  addDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { storage } from "../../firebase";
import { showCustomToast } from "../Misc/CustomToast";
// import DropDownComponentSorted from "../DropDownComponentSorted";
import DropDownComponentNoTitle from "../DropDownComponentNoTitle";
import InputComponentNoTitle from "../InputComponentNoTitle";
import PhoneNumberInputNoTitle from "../PhoneNumberInputNoTitle";
import DropDownComponentSortedNoTitle from "../DropDownComponentSortedNoTitle";
import DatePickerComponentNoTitle from "../DatePickerComponentNoTitle";
import dayjs from "dayjs";
import "./AddClientRedesign.css";
import rehabs from "../../api/rehabs";

const PH_REHAB_ID = "miracles_asia_philippines";

function AddClient(props) {
  // const imageConfig = {
  //   quality: 0.9,
  //   maxWidth: 200,
  //   autoRotate: true,
  //   debug: true,
  // };

  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nickname, setNickName] = useState("");
  const [clientStatus, setClientStatus] = useState("Clinical Assessment");
  const [rehabId, setRehabId] = useState("miracles_asia_thailand");
  // const [gender, setGender] = useState("");
  const [gender] = useState("");

  const [personalEmail, setPersonalEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(0);
  const [country, setCountry] = useState("");
  const [primaryAddiction, setPrimaryAddiction] = useState("");
  const [durationOfStay, setDurationOfStay] = useState("");
  const [eta, setEta] = useState("");
  const [clientSource, setClientSource] = useState("");

  // const [open, setOpen] = React.useState(false);
  // const handleClose = () => setOpen(false);
  // const handleOpen = () => setOpen(true);
  const handlEtaChange = (event) => {
    setEta(event);
  };

  const handleClientSource = (event) => {
    setClientSource(event);
  };

  const handleNicknameChange = (event) => {
    setNickName(event);
  };

  const handleDurationOfStayChange = (value) => {
    setDurationOfStay(value);
  };

  const handleFirstNameChange = (event) => {
    setFirstName(event);
  };

  const handleLastNameChange = (event) => {
    setLastName(event);
  };

  const handlePersonalEmailChange = (event) => {
    setPersonalEmail(event);
  };

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
  };

  const handleCountryChange = (value) => {
    setCountry(value);
  };

  const handleClientStatus = (value) => {
    setClientStatus(value);
  };

  const handleRehabChange = (event) => {
    const nextRehabId = event.target.value;
    setRehabId(nextRehabId);
    if (nextRehabId === PH_REHAB_ID) {
      setDurationOfStay("");
    }
  };

  const handlePrimaryAddictionChange = (event) => {
    setPrimaryAddiction(event);
  };

  const selectedRehab = rehabs.find((rehab) => rehab.id === rehabId);
  const requiresDurationOfStay = rehabId !== PH_REHAB_ID;

  const handleSave = async () => {
    if (
      clientStatus &&
      rehabId &&
      selectedRehab &&
      firstName &&
      lastName &&
      personalEmail &&
      phoneNumber &&
      country &&
      primaryAddiction &&
      (!requiresDurationOfStay || durationOfStay) &&
      clientSource &&
      eta
    ) {
      setIsLoading(true);
      try {
        // Calcul de projectedResidentialDischargeDate basé sur eta et durationOfStay
        let projectedDischargeDate = null;
        let projectedProgramCompletionDate = null;

        if (durationOfStay) {
          const etaDate = eta.toDate();
          const durationDays = parseInt(durationOfStay.match(/\d+/)[0]);
          console.log("Duration Days :", durationDays);
          projectedDischargeDate = dayjs(etaDate)
            .add(durationDays, "day")
            .toDate();

          projectedProgramCompletionDate = dayjs(projectedDischargeDate)
            .add(60, "day")
            .toDate();
        }

        const newClientRef = await addDoc(collection(db, "clients"), {
          creatorName: currentUser.displayName,
          dateOfCreation: serverTimestamp(),
          firstName,
          lastName,
          gender,
          personalEmail,
          phoneNumber,
          country,
          clientStatus,
          rehabId,
          rehabName: selectedRehab.name,
          rehabCountry: selectedRehab.country,
          rehabLocation: selectedRehab.location,
          rehabTimezone: selectedRehab.timezone,
          rehabCurrency: selectedRehab.currency,
          primaryAddiction,
          durationOfStay,
          eta,
          nickname,
          clientSource,
          staffId: currentUser.uid,
          staffEmail: currentUser.email,
          staffName: currentUser.displayName,
          ...(projectedDischargeDate && {
            projectedResidentialDischargeDate:
              Timestamp.fromDate(projectedDischargeDate),
          }),
          ...(projectedProgramCompletionDate && {
            projectedProgramCompletionDate:
              Timestamp.fromDate(projectedProgramCompletionDate),
          }),
        });

        console.log(`Client added with ID: ${newClientRef.id}`);
        showCustomToast("Client successfully added!", "success");

        setIsLoading(false);
        props.closemodal();
      } catch (error) {
        console.error("Error adding client: ", error);
        setIsLoading(false);
        showCustomToast(`Error adding client: ${error}`, "error");
      }
    } else {
      showCustomToast(
        "Some mandatory fields are empty. Please check.",
        "error"
      );
    }
  };

  const renderRequired = () => <span className="add-client-required">*</span>;

  return (
    <div className="add-client-redesign">
      <div className="add-client-redesign-header">
        <div>
          <div className="add-client-redesign-eyebrow">New client</div>
          <h2>Add client</h2>
        </div>
        <button
          className="add-client-redesign-close"
          type="button"
          onClick={props.closemodal}
          aria-label="Close add client modal"
        >
          <CloseIcon fontSize="small" />
        </button>
      </div>

      <div className="add-client-redesign-body">
        <div className="add-client-redesign-alert">
          Fields marked with {renderRequired()} are mandatory.
        </div>

        <section className="add-client-redesign-section">
          <div className="add-client-redesign-section-title">
            Client identity
          </div>
          <div className="add-client-redesign-grid">
            <label className="add-client-field">
              <span>Status {renderRequired()}</span>
              <DropDownComponentSortedNoTitle
                api="clientStatus"
                isRequired={true}
                value={clientStatus}
                onChange={handleClientStatus}
                displayInHouseAsActive={rehabId === PH_REHAB_ID}
              />
            </label>

            <label className="add-client-field">
              <span>Rehab / Facility {renderRequired()}</span>
              <select
                className="add-client-rehab-select"
                value={rehabId}
                onChange={handleRehabChange}
              >
                {rehabs.map((rehab) => (
                  <option key={rehab.id} value={rehab.id}>
                    {rehab.name}
                  </option>
                ))}
              </select>
            </label>

            <label className="add-client-field">
              <span>First Name {renderRequired()}</span>
              <InputComponentNoTitle
                width="300"
                isRequired={true}
                value={firstName}
                onChange={handleFirstNameChange}
              />
            </label>

            <label className="add-client-field">
              <span>Last Name {renderRequired()}</span>
              <InputComponentNoTitle
                width="300"
                isRequired={true}
                value={lastName}
                onChange={handleLastNameChange}
              />
            </label>

            <label className="add-client-field">
              <span>Preferred Name</span>
              <InputComponentNoTitle
                width="300"
                value={nickname}
                onChange={handleNicknameChange}
              />
            </label>
          </div>
        </section>

        <section className="add-client-redesign-section">
          <div className="add-client-redesign-section-title">
            Contact details
          </div>
          <div className="add-client-redesign-grid">
            <label className="add-client-field">
              <span>Personal Email {renderRequired()}</span>
              <InputComponentNoTitle
                width="300"
                value={personalEmail}
                onChange={handlePersonalEmailChange}
              />
            </label>

            <label className="add-client-field">
              <span>Personal Phone Number {renderRequired()}</span>
              <PhoneNumberInputNoTitle
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
              />
            </label>

            <label className="add-client-field add-client-field-wide">
              <span>Country {renderRequired()}</span>
              <DropDownComponentSortedNoTitle
                api="countries"
                title="Country"
                value={country}
                onChange={handleCountryChange}
              />
            </label>
          </div>
        </section>

        <section className="add-client-redesign-section">
          <div className="add-client-redesign-section-title">
            Admission details
          </div>
          <div className="add-client-redesign-grid">
            <label className="add-client-field">
              <span>Primary Addiction {renderRequired()}</span>
              <DropDownComponentNoTitle
                api="addictions"
                title="Primary Addiction (either substance or process above)"
                value={primaryAddiction}
                onChange={handlePrimaryAddictionChange}
              />
            </label>

            {requiresDurationOfStay && (
              <label className="add-client-field">
                <span>Intended Length of Stay {renderRequired()}</span>
                <DropDownComponentSortedNoTitle
                  api="durationOfStay"
                  title="Intended duration of stay"
                  width="250px"
                  value={durationOfStay}
                  onChange={handleDurationOfStayChange}
                />
              </label>
            )}

            <label className="add-client-field">
              <span>Estimate Arrival Date {renderRequired()}</span>
              <DatePickerComponentNoTitle
                title="Estimate Date of Arrival"
                width="150px"
                value={eta}
                onChange={handlEtaChange}
              />
            </label>

            <label className="add-client-field">
              <span>Source {renderRequired()}</span>
              <DropDownComponentSortedNoTitle
                api="clientSource"
                title="Source"
                value={clientSource}
                onChange={handleClientSource}
              />
            </label>
          </div>
        </section>
      </div>

      <div className="add-client-redesign-footer">
        <Button
          className="add-client-redesign-cancel"
          variant="outlined"
          onClick={props.closemodal}
        >
          Cancel
        </Button>
        <Button
          className="add-client-redesign-submit"
          variant="contained"
          onClick={handleSave}
          disabled={isLoading}
        >
          {isLoading ? "Adding client..." : "Add client"}
        </Button>
      </div>
    </div>
  );
}

export default AddClient;
